/**
 * Public Google Apps Script Web App URL.
 * Set REACT_APP_GAS_URL when building for production; this fallback keeps mobile/live working.
 */
export const GAS_URL =
  process.env.REACT_APP_GAS_URL ||
  'https://script.google.com/macros/s/AKfycbwMWg_Ofz1F6ez69F3dGE7lNWpuZxcykRjFXkAh851GK6aVBiosHRL0eZ7RcVFqFA/exec';
